import PrivateVars from './PrivateVars';

// const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB /*|| window.shimIndexedDB*/;
// window.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
// window.IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction;
// window.IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange

const STORE_NAME = 'files';

function access(self) {
    let db = PrivateVars.get(self, 'db');
    if (db !== undefined) {
        let name = PrivateVars.get(self, 'name');
        let transaction = db.transaction([name], "readwrite");
        let store = transaction.objectStore(name);
        return { db, store, transaction }
    } else {
        return undefined;
    }
}

export default class Storage {

    get name() { return PrivateVars.get(this, 'name'); }

    get database() { return PrivateVars.get(this, 'database'); }

    constructor(name, database) {

        // Optional DB name
        database = database || 'storage';

        // Open (or create) the database
        var openRequest = indexedDB.open(database);

        var queue = [];
        PrivateVars.set(this, 'queue', queue);
        PrivateVars.set(this, 'database', database);
        PrivateVars.set(this, 'name', name);

        // Create the schema
        openRequest.onupgradeneeded = ev => {
            var db = openRequest.result;
            // console.log(`Creating Database Stores for '${db.name}'.`);
            let store = db.createObjectStore(name, { keyPath: 'path' });
            store.createIndex('path', 'path', { unqiue: true });
            store.createIndex('date', 'date');
        };

        //  
        openRequest.onsuccess = ev => {
            let db = PrivateVars.set(this, 'db', openRequest.result);
            // console.log("Database Open Success:", db);

            // If actions have queue'd up.
            while (queue.length > 0) {
                let action = queue.pop();

                // Perform appropriate action
                switch (action.type) {

                    case 'put':
                        // Put transaction
                        this.put(action.path, action.value)
                            .then(action.resolve, action.reject);
                        break;

                    case 'get':
                        // Get transaction
                        this.get(action.path)
                            .then(action.resolve, action.reject);
                        break;

                    case 'clear':
                        // Clear transaction
                        this.clear()
                            .then(action.resolve, action.reject);
                        break;

                    case 'delete':
                        // Delete transaction
                        this.delete(action.path)
                            .then(action.resolve, action.reject);
                        break;
                }
            }
        };

        // 
        openRequest.onerror = ev => reject(ev.target.error);
    }

    clear() {
        const db = access(this);

        if (db) {
            let req = db.store.clear();
            return new Promise((resolve, reject) => {
                req.onsuccess = ev => resolve(ev.target.result);
                req.onerror = ev => reject(ev.target.error);
            });
        } else {
            let queue = PrivateVars.get(this, 'queue');
            return new Promise((resolve, reject) => {
                queue.unshift({
                    type: 'clear',
                    resolve: resolve,
                    reject: reject
                });
            });
        }
    }

    put(path, value) {
        const db = access(this);

        if (db) {
            let req = db.store.put({ path: path, date: Date.now(), data: value });
            return new Promise((resolve, reject) => {
                req.onsuccess = ev => resolve({ path: path, data: ev.target.result });
                req.onerror = ev => reject(ev.target.error);
            });
        } else { 
            let queue = PrivateVars.get(this, 'queue');
            return new Promise((resolve, reject) => {
                queue.unshift({
                    type: 'put',
                    path: path,
                    value: value,
                    resolve: resolve,
                    reject: reject
                });
            });
        }
    }

    get(path) {
        const db = access(this);

        if (db) {
            let req = db.store.get(path);
            return new Promise((resolve, reject) => {
                req.onsuccess = ev => {
                    if (ev.target.result) resolve(ev.target.result);
                    else resolve({ path: path, data: undefined, date: undefined });
                }
                req.onerror = ev => reject(ev.target.error);
            });
        } else { 
            let queue = PrivateVars.get(this, 'queue');
            return new Promise((resolve, reject) => {
                queue.unshift({
                    type: 'get',
                    path: path,
                    resolve: resolve,
                    reject: reject
                });
            });
        }
    }

    delete(path) {
        const db = access(this);
        if (db) {
            let req = db.store.delete(path);
            return new Promise((resolve, reject) => {
                req.onsuccess = ev => resolve({ path: path, data: ev.target.result });
                req.onerror = ev => reject(ev.target.error);
            });
        } else { 
            let queue = PrivateVars.get(this, 'queue');
            return new Promise((resolve, reject) => {
                queue.unshift({
                    type: 'delete',
                    path: path,
                    resolve: resolve,
                    reject: reject
                });
            });
        }
    }
}